import { ListTemplate } from '@/types/lists';
import { useTemplatesStore } from '@/store/templatesStore';
import { TemplateItemList } from './TemplateItemList';
import { cn } from '@/utils/cn';

interface TemplateItemManagerProps {
  template: ListTemplate;
  className?: string;
}

export function TemplateItemManager({ template, className }: TemplateItemManagerProps) {
  const { templates } = useTemplatesStore();

  // Get latest template data from store
  const currentTemplate = templates.find(t => t.id === template.id) || template;

  return (
    <div className={cn('space-y-6', className)}>
      {/* Items List - QuickItemEntry moved to header menu modal */}
      <TemplateItemList
        templateId={currentTemplate.id}
        items={currentTemplate.items}
        allowEditing={true}
        allowReordering={true}
      />
    </div>
  );
}
